import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from '@reach/router';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
import { Button, Grid, Typography, Paper, IconButton, TextField } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import Redux from 'spwa-ui-library/esm/redux';
import Loader from '../../components/Loader';
import css from './index.module.scss';
import { sendOtp, selectOtpID } from 'spwa-ui-library/esm/redux/store/authSlice';
import Cookies from 'js-cookie';
import { requestOtpEmailGA, otpResponseEmailGA } from 'spwa-ui-library/esm/utils/helperGA';
import PHBackButton from '../../components/PHBackButton';
const { useDispatch, useSelector } = Redux;

// TODO: Do not use a separate container for OTP
// TODO: Find a way to avoid setting proxy in package.json

function AddEmail() {
  const [pageLoader, setPageLoader] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const location = useLocation();
  const otpId = useSelector(selectOtpID);
  const { cCode, phnNo, retUrl, oldLocation } = location.state || {};
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [otpError, setOtpError] = useState('');
  const countryName = Cookies.get('country') ? Cookies.get('country') : 'UAE';

  const handleForm = () => {
    setPageLoader(true);
    requestOtpEmailGA();
    dispatch(
      sendOtp({
        cCode,
        phnNo,
        email: email,
        otpId,
        sendOtpVia: 'OTP',
        country: countryName,
        otpVia: 'EMAIL',
      })
    )
      .then((resp) => {
        otpResponseEmailGA('Doesn’t Exist');
        if (resp?.payload?.data?.type === 'OTP_SENT') {
          navigate(`/${intl.locale}/verifyOTP`, {
            replace: true,
            state: {
              cCode,
              email: email,
              retUrl: retUrl,
              otpId,
              oldLocation: oldLocation,
            },
          });
        } else {
          setOtpError(resp.payload.data.message);
        }
        setPageLoader(false);
      })
      .catch((error) => {
        // setDisableSubmit(false);
        setPageLoader(false);
        // TODO: Handle send otp error
      });
  };
  const titleDesc = (
    <Grid className={css.textContainer}>
      <Grid className={css.headerText}>
        <Typography>
          <FormattedMessage id="emailotp_otp1" defaultMessage="Enter A Valid" />
        </Typography>
      </Grid>
      <Grid className={css.headerText + ' ' + css.boldText}>
        <Typography>
          <FormattedMessage id="emailotp_otp2" defaultMessage="Email Id Below" />
        </Typography>
      </Grid>
      <Grid>
        <Typography className={css.secondaryText}>
          <FormattedMessage
            id="emailotp_secondary"
            defaultMessage={`We will send a 4 digit OTP on it`}
          />
        </Typography>
      </Grid>
    </Grid>
  );

  const handleEmailInput = (e) => {
    const { value } = e.target;
    setEmail(value);
    validationEmail(value);
  };
  const validationEmail = (emailInput) => {
    let email = emailInput;
    let pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    if (email.match(pattern)) {
      setDisableSubmit(false);
      setEmailError(false);
    } else {
      setDisableSubmit(true);
      setEmailError(true);
    }

    if (email == '') {
      setDisableSubmit(true);
      setEmailError(true);
    }
  };
  useEffect(() => {
    if (otpId === '') {
      navigate(`/${intl.locale}/login`);
    }
  }, [intl.locale, navigate, otpId, phnNo]);

  const submitButton = (
    <Grid className={css.verifyBgClr1}>
      <Button
        className={css.button}
        variant="contained"
        color="primary"
        onClick={handleForm}
        disabled={disableSubmit}
      >
        <FormattedMessage id="continue" defaultMessage="Continue" />
      </Button>
    </Grid>
  );
  useEffect(() => {
    if (!otpId) {
      navigate(`/${intl.locale}/login`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBack = () => {
    navigate(`/${intl.locale}/login`, {
      state: { oldLocation: oldLocation || location, phnNo },
      replace: true,
    });
  };

  return (
    <>
      <Grid className={css.root}>
        {pageLoader && <Loader />}
        <PHBackButton onclick={handleBack} />
        {/* <Grid>
          <IconButton className={css.backButton} onClick={handleBack}>
            {'<'}
          </IconButton>
        </Grid> */}
        <Grid>
          {titleDesc}
          <Paper className={css.otpContainer}>
            <Grid className={css.emailInput}>
              <TextField
                label={<FormattedMessage id="emailUpper" defaultMessage="Email" />}
                className={css.emailField}
                required
                fullWidth
                value={email}
                onChange={handleEmailInput}
                type="email"
              />
              {/* <TextField
                className={classes.root}
                fullWidth
                id="standard-required"
                label="Email"
                variant="standard"
                name="email"
                onChange={handleEmailInput}
                value={email}
              /> */}
              <Grid className={css.warningText}>
                {emailError ? (
                  <FormattedMessage
                    id="email_validate"
                    defaultMessage="Please Enter a valid Email"
                  />
                ) : (
                  ''
                )}
                {otpError ? otpError : ''}
              </Grid>
              {submitButton}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default AddEmail;
